module.exports = function* chainIterators(iterators) {
    for (const it of iterators) {
        yield* it;
    }
}
